import { EnumDictionary } from '../interfaces/enumDictionary';

// eslint-disable-next-line import/export, no-shadow, no-unused-vars
enum Banks {
    // eslint-disable-next-line no-unused-vars
    Efibank = 'efibank'
}

const BanksList: EnumDictionary<Banks, string> = {
  [Banks.Efibank]: 'Efibank'
};

// eslint-disable-next-line import/export
export { Banks, BanksList };
